<template>
  <v-dialog
    :value="value"
    width="560"
    @input="onInput"
  >
    <v-card class="mirror-geo-list-dialog">
      <v-card-title class="body-1" primary-title>
        {{ title }}
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-8 pt-2">
        <div
          v-if="countries.length"
          class="mirror-geo-list-dialog__chips d-flex flex-wrap"
        >
          <lang-chip
            v-for="code in countries"
            :key="code"
            class="mirror-geo-list-dialog__chip"
            :color="listKind === 'locale' ? chipLocaleColor(code) : ''"
            :color-text="listKind === 'locale' ? chipLocaleColorText(code) : 'black--text'"
            :lang="langFromCode(code)"
          />
        </div>
        <span v-else class="body-2 grey--text">No items</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import LangChip from '@/components/core/SelectLang/LangChip.vue'
  import { allCountries, localeToIsoPrefix, mapperIsoLangToOurLocal } from '@/components/core/SelectLang/mapperIsoLocale'

  export default {
    name: 'MirrorGeoListDialog',
    components: { LangChip },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      countries: {
        type: Array,
        default: () => [],
      },
      listKind: {
        type: String,
        default: 'geo',
      },
      defaultLocale: {
        type: String,
        default: null,
      },
    },

    methods: {
      chipLocaleColor(code) {
        return this.defaultLocale != null && code === this.defaultLocale ? '#219653' : '#6FCF97'
      },
      chipLocaleColorText(code) {
        return this.defaultLocale != null && code === this.defaultLocale ? 'white--text' : 'black--text'
      },
      langFromCode(code) {
        const base = {
          locale:  code,
          urlFlag: mapperIsoLangToOurLocal(localeToIsoPrefix(code)),
        }

        if (this.listKind === 'locale') return base

        const [geo, device = 'all'] = code.split('-')
        const iso       = localeToIsoPrefix(geo).toUpperCase()
        const baseLabel = allCountries.find(c => c.value === iso)?.fullName ?? code

        return {
          ...base,
          fullName: device !== 'all' ? `${baseLabel}-${device}` : baseLabel,
        }
      },
      close() {
        this.$emit('input', false)
      },
      onInput(v) {
        this.$emit('input', v)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mirror-geo-list-dialog {
    &__chips {
      gap: 10px;
    }

    &__chip {
      border: 1px solid #585858;
      width: auto;
      min-width: 80px;

    }
  }
</style>
